import React from 'react';
import { MapContainer as LeafletMap, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import './styles.scss';

const mapStyles = {
	width: '100%',
	position: 'relative',
	minHeight: '38rem',
};

const markerIcon = new L.Icon({
	iconUrl: 'https://darsur.com.ar/images/marker-google-map.png',
	iconRetinaUrl: 'https://darsur.com.ar/images/marker-google-map.png',
	iconSize: [40, 56],
	iconAnchor: [21, 56],
});

const MapContainer = () => {
	const markerPosition = { lat: -38.728561, lng: -62.268389 };

	return (
		<LeafletMap
			center={markerPosition}
			zoom={15}
			style={mapStyles}
			scrollWheelZoom={false}
			className="map-blue-filter"
		>
			<TileLayer
				attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
				url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
			/>
			<Marker position={markerPosition} icon={markerIcon} />
		</LeafletMap>
	);
};

export default MapContainer;
